import AOS from 'aos';
import mixpanel from 'mixpanel-browser/src/loaders/loader-module-core';
import { createApp } from 'vue';

import '@/styles/reset.scss';

import '@/styles/fonts.scss';
import '@/styles/variables.scss';

import 'aos/dist/aos.css';

import i18n from './i18n.ts';

import App from './App.vue';

mixpanel.init(import.meta.env.VITE_MP_KEY, {
  api_host: 'https://api-eu.mixpanel.com',
  autocapture: false,
  record_sessions_percent: 0,
});

const app = createApp(App);
app.use(i18n);

app.mount('#app');

AOS.init({ once: true });
